// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DRHM","placeholdersHeader":"styles_placeholdersHeader__1nZ4h","editorStyle":"styles_editorStyle__ZfkFZ","placeholdersBox":"styles_placeholdersBox__1CXUO"};